import { WebGLRenderer } from 'three'

export { Screen }

class Screen extends WebGLRenderer {
    #rolling = false
    #camera
    #scene

    constructor(canvas) {
        super({
            canvas,
            antialias: true,
            alpha: true,
            preserveDrawingBuffer: true
        })
        this.resize()
    }

    project(scene, camera) {
        this.#camera = camera
        this.#scene = scene
    }

    rolling(isRolling = true) {
        this.#rolling = isRolling
    }

    // Rerender for animations

    tick() {
        if (!this.#rolling) return

        if (this.#camera && this.#scene) this.render(this.#scene, this.#camera)
    }

    // Sizing

    resize(size = null) {
        size ??= [
            document.documentElement.clientWidth,
            document.documentElement.clientHeight
        ]

        this.setSize(...size)
        this.setPixelRatio(Math.min(window.devicePixelRatio, 2))
    }

}
